const getAcceptTCRequest = state => state.AcceptTC.acceptTcRequest

export { getAcceptTCRequest }
